import { useState, useEffect } from 'react';

const useDebounce = (inputVal, delay = 400) => {
  const [debouncedText, setDebouncedText] = useState(inputVal);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedText(inputVal);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [inputVal, delay]);

  return debouncedText;
};

export default useDebounce;